import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { API_BASE_PATH } from './constants';
import { TAgentFirmUserResponse } from './types';

type UseAgentFirmUserOptions = {
  agentFirmId: string;
  userId: string;
  extends?: 'SERVICE_REQUESTS'[];
  enabled?: boolean;
};

export function useAgentFirmUser(options: UseAgentFirmUserOptions) {
  const {
    agentFirmId,
    userId,
    extends: extendsParam,
    enabled = true,
  } = options;

  const query = new URLSearchParams();
  if (extendsParam?.length) {
    extendsParam.forEach((ext) => query.append('extends', ext));
  }

  const queryString = query.toString();
  const url = queryString
    ? `${API_BASE_PATH}/${agentFirmId}/users/${userId}?${queryString}`
    : `${API_BASE_PATH}/${agentFirmId}/users/${userId}`;

  const {
    data,
    error,
    mutate,
    isLoading,
  }: {
    data?: TAgentFirmUserResponse;
    error?: unknown;
    mutate: KeyedMutator<TAgentFirmUserResponse>;
    isLoading: boolean;
  } = useSWR(
    enabled && agentFirmId && userId ? url : null,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data: data?.user,
    error,
    mutate,
    isLoading,
  };
}
